import { ISoftEdgeModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { BasePresetUtil, EMPTY_EFFECT } from './base-preset-util';
import * as ICON from '../soft-edge-preset-menu/preset-icons';
import _isEmpty from 'lodash/isEmpty';

const PresetIconOnShow = {
    [EMPTY_EFFECT]: ICON.DrawerEMPTY,
    'soft-10': ICON.DrawerSoft10,
    'soft-25': ICON.DrawerSoft25,
    'soft-50': ICON.DrawerSoft50,
};

const DefaultSoftEdgeProps = {
    size: 0,
};

export class SoftEdgePresetUtil extends BasePresetUtil {
    protected presetIcon = PresetIconOnShow;
    protected defaultEffectProps = DefaultSoftEdgeProps;

    protected getIconName(info: ISoftEdgeModelVal): string {
        if (_isEmpty(info)) return EMPTY_EFFECT;
        const { size } = info;
        if (size === 0) {
            return EMPTY_EFFECT;
        }
        if (size <= 1) {
            return 'soft-1';
        }
        if (size <= 2.5) {
            return 'soft-2.5';
        }
        if (size <= 5) {
            return 'soft-5';
        }
        if (size <= 25) {
            return 'soft-25';
        }
        return 'soft-50';
    }
}
